'use client';

import { NumberInput, NumberInputProps } from '../../controls/number-input';
import FieldWrapper, { FieldWrapperProps } from './field-wrapper';
import { useController, UseControllerProps, FieldValues } from 'react-hook-form';

export interface NumberFieldProps<T extends FieldValues>
  extends UseControllerProps<T>,
    Omit<NumberInputProps, 'defaultValue' | 'name' | 'className'>,
    Omit<FieldWrapperProps, 'children'> {}

export const NumberField = <T extends FieldValues>({ label, required, showError, ...props }: NumberFieldProps<T>) => {
  const {
    field,
    fieldState: { error }
  } = useController(props);

  return (
    <FieldWrapper label={label} showError={showError} error={error} required={required}>
      <NumberInput error={error} {...field} autoComplete="off" {...props} />
    </FieldWrapper>
  );
};
